<template>
  <vs-row id="appSettingsPage" vs-type="flex" vs-w="12">
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between">
      <vs-col
        vs-type="flex"
        vs-w="4"
        :key="indextr"
        v-for="(row, index) in integrations"
      >
        <router-link
          :to="`/pages/integration/${row.id}`"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div class="m-3">
            <img
              v-if="integrations[index].logo != null"
              :src="integrations[index].logo"
              alt="img"
              class="responsive"
            />
            <!-- <span class="text-primary bold text-medium">{{
              integrations[index].name
            }}</span> -->
          </div>
        </router-link>
      </vs-col>
    </vs-row>
  </vs-row>
</template>
<script>
import { getIntegrations } from "@/api/Integration";
export default {
  data() {
    return {
      integrations: [],
    };
  },
  created: async function () {
    await this.loadIntegrations();
  },
  methods: {
    async loadIntegrations() {
      try {
        const response = await getIntegrations();
        this.integrations = response.data;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Entegrasyonlar yüklenirken bir hata oluştu!",
        });
      }
    },
  },
};
</script>
